export const FILTER_SETS_TAG_TYPE = 'FilterSet' as const;
